export const LINK_BANK_FIND_OFFICE = 'https://www.unicreditbank.ru/ru/branch-finder.html';
